import woman from "../../../../images/woman_icon.png"
import ticket from "../../../../images/ticket_icon.png"
import online from '../../../../images/online_icon.png'

export const conditionIcons = {
    "Women Only": woman,
    "Requires pre-registration": ticket,
    "Limited Tickets": ticket,
    "Online": online,
  }